// 黑名單登入失敗彈窗

const LoginFailModal = ({ t, dispatch, setShowLoginFailModal }) => {
    return (
        <div className="modal">
            <div className="w-[266px] rounded-[12px] py-[20px] px-[8px] text-center bg-black space-y-[22px] shadow-[0_0_20px_0_rgba(135,135,135,.25)]">
                <p className="text-h5 text-white pb-[22px] border-b-1 border-dashed border-black2">
                    {t('LOGIN_FAIL')}
                </p>

                <p className="text-bd4n text-white">{t('LOGIN_FAIL_CONTENT')}</p>

                <a
                    href="mailto:news@sounova.com"
                    className="text-btn1 block text-white trans w-[220px] rounded-[6px] mx-auto px-[22px] py-[13px] bg-bou hover:bg-purple"
                    onClick={() => dispatch(setShowLoginFailModal(false))}
                >
                    {t('CONTACT')}
                </a>
            </div>

            <div className="close-bg" onClick={() => dispatch(setShowLoginFailModal(false))} />
        </div>
    );
};

export default LoginFailModal;
